import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudCpeService } from '../datosbasicos/cpe.service';
import { SolicitudCpeViewModel } from '../datosbasicos/cpe.types';
import { EnumIdsTcEstadoSolicitudCpe } from '../types/enum';
import { EnvioCpeService } from './envioCpe.service';

@Component({
    selector: 'app-enviocpe-edit',
    templateUrl: './envioCpe-edit.component.html',
})
export class EnvioCpeEditComponent extends ComponentBase implements OnInit {
    solicitudCpe: SolicitudCpeViewModel;
    habilitarEnviar: boolean = false;
    habilitarPrintCPE: boolean = false;
    fechaSolicitud: string | null;
    tituloEstadoSolicitud: string;
    IdSolicitudCpe: number;

    visibilitySpinner: boolean = false;
    visibilityCheckEnvio: boolean = false;
    codigo: string;
    validacionCollection: string[];

    public isCollapsedDatosEnvio = false;
    public isCollapsedDatosCPE = false;

    public visibilitySpinnerPrintCPE = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,

        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private cpeService: SolicitudCpeService,
        private envioCpeService: EnvioCpeService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudCpe = new SolicitudCpeViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];

        this.IdSolicitudCpe = id;

        this.guardRefreshPage(id);

        this.createForm();

        //VALIDACION INICIAL
        this.envioCpeService.validarSolicitud(id).subscribe(result1 => {
            //this.validacionCollection = result; //01072022. Solo si es borrador

            if (id) {
                this.cpeService.getEnvioSolicitud(id).subscribe(result2 => {
                    this.solicitudCpe = result2;

                    if (
                        this.solicitudCpe.IdEstado == EnumIdsTcEstadoSolicitudCpe.ID_BORRADOR ||
                        this.solicitudCpe.IdEstado == EnumIdsTcEstadoSolicitudCpe.ID_REVISION_SOLICITANTE
                    ) {
                        this.validacionCollection = result1; //01072022. Solo si es borrador o revisión
                    }

                    this.fechaSolicitud = this.datepipe.transform(this.solicitudCpe.FechaEnvio, 'dd/MM/yyyy');
                    this.tituloEstadoSolicitud = this.solicitudCpe.TwTcEstadoCertificadoPrevioEx.Descripcion;

                    this.codigo = this.solicitudCpe.Codigo;

                    this.updateForm();

                    this.habilitarEnviar =
                        this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ENVIAR_SOLICITUD_CPE, this.solicitudCpe.IdEstado).Visible &&
                        (this.validacionCollection == null || this.validacionCollection.length == 0);
                    this.habilitarPrintCPE = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_ENVIO_CPE, this.solicitudCpe.IdEstado).Editable;

                    this.visibilityCheckEnvio = this.habilitarEnviar;
                });
            }
        });
    }

    createForm() {
        this.form = this.fb.group({
            Codigo: '',
            FechaEnvio: null,
            FechaCertificacion: '',
            NumeroCertificado: '',
        });
    }

    updateForm() {
        this.form.setValue({
            Codigo: this.solicitudCpe.Codigo,
            FechaEnvio: this.datepipe.transform(this.solicitudCpe.FechaEnvio, 'dd/MM/yyyy'),
            FechaCertificacion: this.datepipe.transform(this.solicitudCpe.FechaEmision, 'dd/MM/yyyy'),
            NumeroCertificado: this.solicitudCpe.NumeroCertificado,
        });
    }

    guardRefreshPage(id: number) {
        //Fuerzo que lo haga siempre pq fallaba al refrescar cuando cambiaba de estado
        if (id) {
            // && !this.navMenuService.currentSolicitudImportacion.Id) {

            this.cpeService.getSolicitudCpe(id).subscribe(result => {
                this.navMenuService.currentSolicitudCpe = result;
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/cpe/datosbasicos', this.solicitudCpe.Id]);
    }

    onPrintCPE() {
        this.visibilitySpinnerPrintCPE = true;
        this.envioCpeService.getCertificadoPrevioEx(this.solicitudCpe.Id).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
                this.visibilitySpinnerPrintCPE = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerPrintCPE = false;
            },
        });
    }

    enviarSolicitud() {
        this.confirmationService.confirm({
            message: '¿Está seguro de enviar la solicitud?',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onSubmit() {
        this.submitted = true;

        this.visibilitySpinner = true;

        //Si no hay errores ENVIO
        this.envioCpeService.envioSolicitud(this.solicitudCpe).subscribe({
            next: () => {
                this.addSuccessMessage('Solicitud enviada correctamente');

                //se manda el correo
                //this.envioCpeService.sendMailAtestacionEnviada(this.IdSolicitudCpe)
                //    .subscribe(r => {
                //        if (r) {
                //            this.addSuccessMessage("Correo enviado correctamente");
                //        }
                //    })

                this.ngOnInit();
                this.visibilitySpinner = false;
            },
            error: error => {
                this.catchServerError(error);

                this.visibilitySpinner = false;
            },
        });
    }
}
